import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash";
import { Grid, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Button, FormHelperText, Box } from '@mui/material';

import FileUpload from '../../common/FileUpload';
import DatePicker from '../../common/DatePicker';
import InputText, { InputSelectNative } from '../../common/Form';
import Creatable from '../../common/Creatable';
import PostForm from '../Incomes/PostForm';

class FactureForm extends Component {
    state = { 
        facture_post: this.props.facture && this.props.facture.facture_post ? {
            value: this.props.facture.facture_post, 
            label: this.props.POSTS[this.props.facture.facture_post].post_name
        } : {value:"", label:""},
        facture_desc: this.props.facture ? this.props.facture.facture_desc : "",
        facture_ref: this.props.facture ? this.props.facture.facture_ref : "",
        facture_id: this.props.facture ? this.props.facture.facture_id : "",
        // facture_payment_mode: this.props.facture ? this.props.facture.facture_payment_mode : "",
        // facture_bank: this.props.facture ? this.props.facture.facture_bank : "",
        facture_amount: this.props.facture ? parseFloat(this.props.facture.facture_amount) : "",
        facture_files: null,
        facture_date: this.props.facture ? this.props.facture.facture_date : new Date(),
        
        errors: {
            facture_date: "",
            facture_desc: "",
            facture_post: "",
            facture_ref: "",
            // facture_payment_mode: "",
            // facture_bank: "",
            facture_amount: "",
            facture_files: "",
        },
        factureList: [],
        available: ""
        
    }

    handleChange = (e) => {
        const { name, value} = e.target;
        
        this.setState({
            [name]: value
        })        
    }

    handleChangeDate = (date) => {
        this.setState({
            facture_date: date
        })
    }
    handleChangeSelect = (option, name) => {
        if(option){
            this.setState({
                [name]: option
            })
        } else {
            this.setState({
                [name]: {}
            })
        }
    }
    createNew = (field, name) => {
        this.setState({
            [field]: true,
            nameNew: name
        })
    }
    setFiles = (facture_files, error = "") => {
        console.log("[INFO] SET_PHOTO", facture_files);
        this.setState({
            facture_files,
            errors:{
                ...this.state.errors,
                facture_files:error
            }
        })
    }
    validate = () => {
        let required = [
            "facture_post",
            "facture_amount",
            "facture_ref",
            "facture_desc",
            // "facture_payment_mode",
            // "facture_bank",
            "facture_files"
        ]
        if (this.props.update){
            required = [
                "facture_post",
                "facture_amount",
                "facture_ref",
                "facture_desc",
                // "facture_payment_mode",
                // "facture_bank",
            ]
        }
        
        let noError = true
        let errors = {}
        
        required.map(field => {
            if( isEmpty(this.state[field]) && !this.state[field] ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else if( field === "facture_post" && isEmpty(this.state[field].value)){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        
        this.setState({
            errors
        })
        
        return noError
    }
    handleSubmit = async () => {

        if( this.validate() ){
            let data = {}
            if(this.props.update){
                data = Object.assign({}, this.props.facture)
            } else {
                data.facture_files =  this.state.facture_files
            }
            data.facture_amount =  parseFloat(this.state.facture_amount)
            // data.facture_payment_mode = this.state.facture_payment_mode
            // data.facture_bank =  this.state.facture_bank
            data.facture_post =  this.state.facture_post.value
            data.facture_ref =  this.state.facture_ref
            data.facture_date =  this.state.facture_date
            data.facture_desc =  this.state.facture_desc
            
            
            console.log('====================================');
            console.log("submit facture", {data});
            console.log('====================================');
            
            if (this.props.update) {
                await this.props.updateFacture(data)
            } else {
                await this.props.newFacture(data)
            }
            

            // // if NoErrors ...
            if(this.props.STATE.factures.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.factures.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        const { BANKS, POSTS, STATE } = this.props;
        const { nameNew, formPost} = this.state;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Dialog
                // disableBackdropClick
                open={true}
                // onClose={this.props.handleClose}
                onClose={(_, reason) => {reason !== "backdropClick" && this.props.handleClose()} }
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth= "md"
                scroll="body"
            >
                {formPost &&
                    <PostForm
                        POSTS={POSTS}
                        STATE={STATE}
                        post={{post_name: nameNew}}
                        handleClose={() => this.setState({ formPost: false, nameNew: "" })}
                        newPost={this.props.newPost}
                        notif={this.props.notif}
                    />
                }
                <DialogTitle id="form-dialog-title">Ajouter une facture</DialogTitle>
                <DialogContent>
                    <Grid container >
                        <Grid item sm={6} xs ={12}>
                            <DatePicker  
                                id="facture_date" 
                                label="Date" 
                                name="facture_date" 
                                value={this.state.facture_date} 
                                handleChange={this.handleChangeDate} 
                                error={this.state.errors.facture_date}
                                required
                            />      
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="facture_ref"
                                error={this.state.errors.facture_ref}
                                value={this.state.facture_ref}
                                name="facture_ref"
                                label="Référence"
                            />

                            <Creatable
                                required
                                label="Poste"
                                error={this.state.errors.facture_post}
                                id="facture_post"
                                options={Object.values(POSTS).map( item => ({
                                    label: item.post_name,
                                    value: item.post_id
                                }))}
                                value={this.state.facture_post}
                                openPopUp={(name) => this.createNew("formPost", name)}
                                onChange={(option) => this.handleChangeSelect(option, "facture_post" )}
                            />
                            
                            {/* <InputSelectNative
                                label="Banque"
                                onChange={this.handleChange}
                                error={this.state.errors.facture_bank}
                                value={this.state.facture_bank}
                                labelWidth={60} 
                                name="facture_bank" 
                                id="facture_bank" 
                                options={ Object.values(BANKS).map( bank  => (
                                    <option value={bank.bank_id} key={bank.bank_id}>
                                        {bank.bank_name}
                                    </option>
                                )) }
                            />
                            <InputSelectNative
                                label="Mode de Paiement"
                                value={this.state.facture_payment_mode}
                                onChange={this.handleChange}
                                labelWidth={170} 
                                name="facture_payment_mode" id="facture_payment_mode"
                                error={this.state.errors.facture_payment_mode} 
                                options={[
                                    <option value="ESPECES">ESPECES</option>,
                                    <option value="CHEQUE">CHEQUE</option>,
                                    <option value="PRELEVEMENT">PRELEVEMENT</option>,
                                    <option value="VIREMENT">VIREMENT</option>,
                                    <option value="GAB">GAB</option>,
                                    <option value="MOBILE MONEY">MOBILE MONEY</option>
                                ]}
                            /> */}
                            
                            
                        </Grid>
                        <Grid item sm={6} xs ={12}>
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="facture_amount"
                                error={this.state.errors.facture_amount}
                                value={this.state.facture_amount}
                                name="facture_amount"
                                label="Montant"
                                type="number"          
                            />

                            <InputText
                                onChange={this.handleChange}
                                required
                                id="facture_desc"
                                error={this.state.errors.facture_desc}
                                value={this.state.facture_desc}
                                name="facture_desc"
                                label="Description"
                                rows={5}
                                multiline
                            />
                            
                        </Grid>
                    </Grid>
                    {!this.props.update &&
                        <Box p={1}>
                            <FileUpload
                                label="Ajouter un Justificatif"
                                setFiles={this.setFiles} 
                                files={this.state.facture_files || []} 
                            />
                            <FormControl error={!!this.state.errors.facture_files} >
                                <br/>
                                <FormHelperText >{this.state.errors.facture_files}</FormHelperText>
                            </FormControl>
                        </Box>
                    }
                    
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={this.handleSubmit} color="secondary">
                        Valider
                    </Button>
                    <Button onClick={this.props.handleClose} >
                        Annuler
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default FactureForm;